<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData" @submitOtherEst="submitOtherEst">
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>고객 정보</h3></li>
            <template v-if="false">
              <li><element-textbox v-model="processorData.steps[0].formData.name.value" :error="processorData.steps[0].formData.name.error" :label="processorData.steps[0].formData.name.label" :placeholder="processorData.steps[0].formData.name.placeholder" /></li>
            </template>
            <li><element-spread-select v-model="processorData.steps[0].formData.sex.value" :error="processorData.steps[0].formData.sex.error" :label="processorData.steps[0].formData.sex.label" :items="processorData.steps[0].formData.sex.items" /></li>
            <li><element-textbox v-model="processorData.steps[0].formData.birth.value" :error="processorData.steps[0].formData.birth.error" :label="processorData.steps[0].formData.birth.label" :placeholder="processorData.steps[0].formData.birth.placeholder" /></li>
            <div class="form-item-caution">정확한 보험료 산출을 위해 활용됩니다.</div>
          </ul>
          <ul class="form-item-list">
            <li><element-spread-select v-model="processorData.steps[0].formData.job.value" :error="processorData.steps[0].formData.job.error" :label="processorData.steps[0].formData.job.label" :items="processorData.steps[0].formData.job.items" /></li>
          </ul>
          <div class="form-item-caution">찾는 직업이 없는경우, 가장 비슷한 직업으로 선택하신 후 상담예약에 내용을 남겨주시면 해당하는 직업으로 변경해 드립니다.</div>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[1]">
          <ul class="form-item-list">
            <li><h3>보장항목</h3></li>
            <li><element-select v-model="processorData.steps[1].formData.insureDuration.value" :error="processorData.steps[1].formData.insureDuration.error" :label="processorData.steps[1].formData.insureDuration.label" :placeholder="processorData.steps[1].formData.insureDuration.placeholder" :items="processorData.steps[1].formData.insureDuration.items" /></li>
            <li v-for="(options, index) in processorData.steps[1].formData.insureOptions" :key="index">
              <element-content-checkbox @status="popup" v-model="processorData.steps[1].formData.insureOptions[index].value" :error="processorData.steps[1].formData.insureOptions[index].error" :label="processorData.steps[1].formData.insureOptions[index].label" :items="processorData.steps[1].formData.insureOptions[index].items" :index="index" :requirement="processorData.steps[1].formData.insureOptions[index].requirement"/>
            </li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[2]">
          <ul class="form-item-list" id="history-of-treatment">
            <li><h3>치료이력</h3></li>
            
            <li><element-textbox v-model="processorData.steps[2].formData.name.value" :error="processorData.steps[2].formData.name.error" :label="processorData.steps[2].formData.name.label" :placeholder="processorData.steps[2].formData.name.placeholder" /></li>
            <li><element-textbox v-model="processorData.steps[2].formData.birth.value" :error="processorData.steps[2].formData.birth.error" :label="processorData.steps[2].formData.birth.label" :placeholder="processorData.steps[2].formData.birth.placeholder" /></li>

            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.history.value" :error="processorData.steps[2].formData.history.error" :label="processorData.steps[2].formData.history.label" :items="processorData.steps[2].formData.history.items" /></li>
            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.inject.value" :error="processorData.steps[2].formData.inject.error" :label="processorData.steps[2].formData.inject.label" :items="processorData.steps[2].formData.inject.items" /></li>
            <li id="history-of-treatment-item"><element-checkbox v-model="processorData.steps[2].formData.have.value" :error="processorData.steps[2].formData.have.error" :label="processorData.steps[2].formData.have.label" :items="processorData.steps[2].formData.have.items" /></li>
            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.denture.value" :error="processorData.steps[2].formData.denture.error" :label="processorData.steps[2].formData.denture.label" :items="processorData.steps[2].formData.denture.items" /></li>
            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.dentalhistory.value" :error="processorData.steps[2].formData.dentalhistory.error" :label="processorData.steps[2].formData.dentalhistory.label" :items="processorData.steps[2].formData.dentalhistory.items" /></li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[3]">
          <include-estimate-auth-self :data="processorData.steps[0]" @updateprocessorData="updateprocessorData" />
        </element-processor-step>

        <element-processor-step :data="processorData.steps[4]">
          <ul class="form-item-list">
            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[4].formData.consultDate.value" :error="processorData.steps[4].formData.consultDate.error" :label="processorData.steps[4].formData.consultDate.label" :placeholder="processorData.steps[4].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[4].formData.consultTime.value" :date="processorData.steps[4].formData.consultDate.value" :error="processorData.steps[4].formData.consultTime.error" :label="processorData.steps[4].formData.consultTime.label" :placeholder="processorData.steps[4].formData.consultTime.placeholder" />
            </li>
            <li><element-textarea v-model="processorData.steps[4].formData.consultRemark.value" :error="processorData.steps[4].formData.consultRemark.error" :label="processorData.steps[4].formData.consultRemark.label" :placeholder="processorData.steps[4].formData.consultRemark.placeholder" /></li>
            <li><div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div></li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[5]">
          <include-estimate-complete :data="processorData.steps[5]" />
        </element-processor-step>
        <element-processor-step :data="processorData.steps[6]">
          <include-other-estimate :data="processorData.steps[6]"  :type="processorData.title"/>
        </element-processor-step>
        <transition name="popup">
          <element-popup @status="popup" :process_title="processorData.title" v-model="processorData.steps[1].formData.insureOptions[statusPopup.option].value" @checkPopup="checkValue" :label="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].label"
          :subLabel="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].subLabel" v-if="statusPopup.popup" :statusPopup="statusPopup" :data="processorData.steps[1].formData.insureOptions[statusPopup.option]"
          :description="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>
        </transition>
      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment';

export default {
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "치아보험 견적서",
        cureData: true,
        steps: [
          {
            title: "고객 정보",
            formData: {
              
              sex: {
                label: "성별",
                value: "",
                error: "",
                items: [
                  { value: "남자", label: "남자" },
                  { value: "여자", label: "여자" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              birth: {
                label: "생년월일",
                value: "",
                error: "",
                placeholder: "생년월일 6자리 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" }
                ]
              },
              job: {
                label: "직업",
                value: "",
                error: "",
                items: [
                  { value: "사무,전문직", label: "사무,전문직" },
                  { value: "운수,건설직", label: "운수,건설직" },
                  { value: "판매,서비스직", label: "판매,서비스직" },
                  { value: "영업용 운전직", label: "영업용 운전직" },
                  { value: "학생,주부", label: "학생,주부" },
                  { value: "무직", label: "무직" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              }
            }
          },
          {
            title: "보장항목",
            formData:
            {
              insureDuration: {
                label: "보험 기간",
                value: "80세 만기 15년 갱신",
                error: "",
                items: [
                    { value: "80세 만기 20년 갱신", label: "80세 만기 20년 갱신" },
                    { value: "80세 만기 15년 갱신", label: "80세 만기 15년 갱신" },
                ]
              },
              insureOptions: [
              {
                label: "보장 내용",
                requirement: true,
                value: [
                  { label: "치아보존치료비", value: "치아 3개 보장" },
                  { label: "치아보철치료비", value: "치아 3개 보장" },
                  { label: "치아골이식치료비", value: "100만원" },
                  { label: "발치치료비", value: "2만원" },
                  { label: "발치치료비(영구치)", value: "10만원" },
                  { label: "신경치료비", value: "3만원" },
                  { label: "치아촬영비", value: "1만원" },
                  { label: "치석제거치료비", value: "1만원" },
                  { label: "치주질환수술/턱관절장애치료", value: "30만원" },
                ],
                error: "",
                items: [
                  { value: " 치아보존치료비", label: "치아보존치료비", description: [
                    { value: "피보험자가 치아관련 질병 또는 상해로 치아보존치료(충전치료, 크라운치료)를 받은 경우, 아래의 가입금액 지급" },
                    { value: " -아말감/글래스아이노머 : 치아당 가입금액의 10%지급(1년미만 5%지급)" },
                    { value: "- 아말감/글래스아이노머 이외(레진필링, 인레이, 온레이 등) : 치아당 가입금액의 50%지급(1년미만 25%지급)" },
                    { value: "- 크라운 : 치아당 가입금액의 100%지급(1년미만 50%지급)" }
                  ], subLabel: "치아 3개 보장", link: { name: "Home" },
                    options: [
                      { value: "치아 개수 제한없음", label: "치아 개수 제한없음" },
                      { value: "치아 3개 보장", label: "치아 3개 보장" },
                      { value: "미가입", label: "미가입" },

                    ] },
                  { value: "치아보철치료비", label: "치아보철치료비", description: [
                    { value: "피보험자가 치아관련 질병 또는 상해로 영구치 발거를 진단받고, 해당 영구치에 치아보철치료(임플란트, 브릿지, 틀니)를 받고 해당 보철치료가 종료된 경우,  아래의 가입금액 지급" },
                    { value: "- 임플란트 : 영구치발거 1개당 가입금액의 100%지급(2년미만 70%지급)" },
                    { value: "- 브릿지 : 영구치발거 1개당 가입금액의 50%(2년미만 35%지급)" },
                    { value: "- 틀니 : 보철물당 가입금액의 100%(2년미만 70%지급)" }
                  ], subLabel: "치아 3개 보장", link: { name: "Home" },
                    options: [
                      { value: "치아 개수 제한없음", label: "치아 개수 제한없음" },
                      { value: "치아 3개 보장", label: "치아 3개 보장" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "치아골이식치료비", label: "치아골이식치료비", description: [
                    { value: '피보험자가 치아관련 질병 또는 상해로 영구치 발거를 진단확정 받고, 해당 영구치를 발거한 부위에 임플란트 시술을 받기 위해 "특정 임플란트 치조골 이식술 치료"를 받은 경우, 영구치 발거 1개당 가입금액 지급' }
                  ], subLabel: "100만원", link: { name: "Home" },
                    options: [
                      { value: "100만원", label: "100만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "발치치료비", label: "발치치료비", description: [
                    { value: "피험자가 발치(단순, 정교, 완전매복) 치료를 한 경우, 치아 1개당 아래의 가입금액 지급" },
                    { value: "- 단순발치(맹출치아 및 노출된 치근) : 가입금액의 30% 지급 (KB : 25%)" },
                    { value: "- 정교발치(부분적으로 매복된 치아) : 가입금액의 50% 지급" },
                    { value: "- 완전매복발치(완전 매복된 치아) : 가입금액의 100% 지급" }
                  ], subLabel: "2만원", link: { name: "Home" },
                    options: [
                      { value: "10만원", label: "10만원" },
                      { value: "2만원", label: "2만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "발치치료비(영구치)", label: "발치치료비(영구치)", description: [
                    { value: "피보험자가 영구치상실을 입은 경우 영구치당 가입금액 지급" },
                    { value: "「영구치상실」 : 치아우식증(충치) 또는 치주질환, 외상 등에 의하여 치아가 뿌리까지 손상되어 어떠한 치료를 하더라도 치아의 전부 또는 일부라도 보존할 수 없다고 판단되어 치아를 발거(拔去)한 경우. 단, 아래 원인으로 발거(拔去)하는 경우 제외" },
                    { value: "  ① 제3대구치(사랑니)를 발거하는 경우" },
                    { value: "  ② 교정 및 위치이상 : 교정치료를 위하여 발거(拔去)하였거나 위치이상으로 심미적인 개선을 위하여 발거(拔去)한 경우" },
                    { value: "  ③ 맹출장애 : 부분 매복되거나, 완전 매복되어 발거(拔去)한 경우" }
                  ], subLabel: "10만원", link: { name: "Home" },
                    options: [
                      { value: "10만원", label: "10만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "신경치료비", label: "신경치료비", description: [
                    { value: "피보험자가 치아관련 질병 또는 상해로 치아근관치료를 진단 확정받고 해당 치아에 치아근관치료(치수치료)를 받은 경우 치아당 가입금액 지급(질병으로 치료시 1년미만 50%지급, 1년이상 100%지급)" }
                  ], subLabel: "3만원", link: { name: "Home" },
                    options: [
                      { value: "4만원", label: "4만원" },
                      { value: "3만원", label: "3만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "치아촬영비", label: "치아촬영비", description: [
                    { value: "피보험자가 질병 또는 상해로 치아촬영(X-ray 및 파노라마)을 한 경우, 촬영 1회당 가입금액 지급. 단, 동일한 질병 또는 상해로 2회 이상의 촬영을 한때에는 1회에 한하여 지급" }
                  ], subLabel: "1만원", link: { name: "Home" },
                    options: [
                      { value: "1만원", label: "1만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "치석제거치료비", label: "치석제거치료비", description: [
                    { value: "피보험자가 치석제거(스케일링) 치료를 받은 경우 연간 1회에 한하여 가입금액 지급" }
                  ], subLabel: "1만원", link: { name: "Home" },
                    options: [
                      { value: "1만원", label: "1만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "치주질환수술/턱관절장애치료", label: "치주질환수술/턱관절장애치료", description: [
                    { value: "피보험자가 치주질환수술 및 턱관절장애치료를 받은 경우, 아래의 가입금액 지급" },
                    { value: " 치주질환수술비 : 치주질환으로 진단확정후 그 치료를 목적으로 치주질환수술을 받은 경우 치주질환수술 1회당 가입금액의 10% 지급" },
                    { value: " 턱관절장애수술비 : 턱관절장애로 진단확정후 그 치료를 목적으로 수술을 받은 경우 턱관절장애수술 1회당 가입금액 지급" },
                    { value: " 턱관절절장애입원일당(1일이상) : 턱관절장애로 진단확정후 그 치료를 목적으로 입원한 경우 입원 1일당 가입금액의 10% 지급" }
                  ], subLabel: "30만원", link: { name: "Home" },
                    options: [
                      { value: "30만원", label: "30만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                ],
              }]
            }
          },
          {
            title: "치료이력",
            formData: {
              name: {
                label: "이름",
                value: "",
                error: "",
                placeholder: "이름 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              birth: {
                label: "생년월일",
                value: "",
                error: "",
                placeholder: "생년월일 6자리 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" },
                ]
              },
              history: {
                label: "최근 3개월 이내 질병 또는 상해로 약을 먹거나 치료한 경험이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "치료", label: "치료" },
                  { value: "검사", label: "검사" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              inject: {
                label: "최근 5년 이내 입원, 수술 혹은 30일 이상 투약한 경험이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "2년 이내", label: "2년 이내" },
                  { value: "2~5년", label: "2~5년" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              have: {
                label: "관리하고 있는 질병이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "당뇨병", label: "당뇨병" },
                  { value: "고혈압", label: "고혈압" },
                  { value: "고지혈증", label: "고지혈증" },
                  { value: "뇌혈관질환", label: "뇌혈관질환" },
                  { value: "심혈관질환", label: "심혈관질환" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "array", message: "필수항목입니다" }
                ]
              },
              denture: {
                label: "현재 틀니 착용 여부",
                value: "",
                error: "",
                items: [
                  { value: "착용", label: "착용" },
                  { value: "미착용", label: "미착용" },
                  { value: "기타", label: "기타" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              dentalhistory: {
                label: "최근 1년 이내 치과 치료",
                value: "",
                error: "",
                items: [
                  { value: "치료", label: "치료" },
                  { value: "검사", label: "검사" },
                  { value: "없음", label: "없음" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              }
            }
          },
          {
            title: "본인 확인",
            formData: {
              // haslogin: {
              //   value: "",
              //   validations: [
              //     { type: "required", message: "-" }
              //   ]
              // },
              phone: {
                label: "휴대폰 번호",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              email: {
                label: "이메일",
                value: "",
                // validations: [
                //   { type: "required", message: "-" }
                // ]
              },
              birth: {
                label: "생년월일",
                value: "",
                validations: [
                  { type: "required", message: "-" },
                ]
              },
            }
          },
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ], // steps
        reservation_inflow_referer_source: '',
      }
    }
  },
  created() {
    const { date, time } = this.$getDefaultConsultTime();

    if (date !== '') {
      this.processorData.steps[4].formData.consultDate.value = date;
    }

    this.processorData.steps[4].formData.consultTime.value = time;

    if (this.$route.query.refin) {
      this.reservation_inflow_referer_source = this.$route.query.refin;
    }
  },
  methods: {
    submit( finalData ) {
      var tmp = JSON.parse(JSON.stringify(finalData["상담 예약"]));
      // 상담 예약 제거
      delete finalData["상담 예약"];
      //가입자 , 자필서명
      if(this.$route.query) {
        if(this.$route.query.procstep == "가입자" || this.$route.query.procstep == "본인 확인" || this.$route.query.procstep == "자필서명") {
          this.$store.dispatch( "estimate/createItems", finalData);
        }else if(this.$route.query.procstep == "상담 예약") {
          tmp.step_datas.insureName = { value: finalData.title }
          tmp.step_datas.name = {  value: this.processorData.steps[3].formData.name.value }
          tmp.step_datas.phone = { value: this.processorData.steps[3].formData.phone.value}
          var reservation_data = {
            customer_id: finalData.customer_id,
            "전화상담": tmp
          }

          if (this.reservation_inflow_referer_source !== '') {
            reservation_data.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }
          // 전화상담 예약 전송
          this.$store.dispatch( "reservation/createItems", reservation_data );   
        }
      }
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      var insureOptionsObj = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option];
      insureOptionsObj.items[this.statusPopup.index].subLabel = value;

      var Vidx = insureOptionsObj.value.findIndex(o => o.label === insureOptionsObj.items[this.statusPopup.index].label);
      if(Vidx >= 0){
        
        if(value === '미가입' && !insureOptionsObj.requirement){ 
          // 필수 보장항목이 아니고, 미가입하는경우는 value 목록에서 제거
          insureOptionsObj.value.splice(Vidx, 1);
        }else{
          // 이외 값 변경
          // 단, 값이 Array 인경우가 있으므로 확인 ( 다중선택 가능한경우 )
          if(Array.isArray(insureOptionsObj.value[Vidx].value)) {
            var VIidx = insureOptionsObj.value[Vidx].value.indexOf(value);
            // 이미 arr 값이 있는경우 제거
            if(VIidx >= 0){
              //단, 최소 하나이상 선택하도록 해야하므로
              if(insureOptionsObj.value[Vidx].value.length > 0) insureOptionsObj.value[Vidx].value.splice(VIidx, 1);
            }else{
              // 추가
              insureOptionsObj.value[Vidx].value.push(value)
            }
            insureOptionsObj.items[this.statusPopup.index].subLabel = insureOptionsObj.value[Vidx].value.join();
          }else{
            insureOptionsObj.value[Vidx].value = value;
          }
        }
      }else{
        // value 목록에 없는 경우
        if(value != '미가입'){
          // 미가입 아닌경우 값 추가
          var tmp = { label: insureOptionsObj.items[this.statusPopup.index].value, value: value };
          insureOptionsObj.value.push( tmp )
        }
      }
    },
    updateprocessorData: function (data){
      //this.processorData.steps[3].formData.haslogin.value = data.haslogin;
      this.processorData.steps[3].formData.phone.value = data.phone;
      this.processorData.steps[3].formData.name.value = data.name;
      this.processorData.steps[3].formData.email.value = data.email;
      this.processorData.steps[3].formData.birth.value = data.birth;
    },
    submitOtherEst() {
      var tmp = {
        customer_id: this.$store.state.customer.profile._id,
        "전화상담": {
          step_datas: {
            insureName: { value: "" },
            name: {  value: this.processorData.steps[3].formData.name.value },
            phone: { value: this.processorData.steps[3].formData.phone.value },
            consultDate: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultDate.value },
            consultTime: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultTime.value },
            consultRemark: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value ? this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value : "없음"}
          }
        }
      }
      var ost_data = this.processorData.steps[this.processorData.steps.length - 1];
      if(ost_data.value.length > 0) {
        ost_data.value.forEach(o => {
          tmp["전화상담"].step_datas.insureName.value = o

          if (this.reservation_inflow_referer_source !== '') {
            tmp.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }

          this.$store.dispatch( "reservation/createItems", tmp );
        })
      }
    }
  }
}
</script>
